import { sendToNative } from '@mobi/web-native-comms/web'
import * as cookies from 'js-cookie'

export function isCookieSet(cookieName: string) {
  return getCookieValue(cookieName) !== undefined
}

export function getCookieValue(cookieName: string): string | undefined {
  return cookies.get(cookieName)
}

export function setCookieValue(
  cookieName: string,
  value: string,
  options?: cookies.CookieAttributes
) {
  cookies.set(cookieName, value, options)
}

/// Safely remove a cookie from both the web and native side. Setting a
/// cookie is synced automatically, but removing needs an explicit call
export function clearCookieValue(cookieName: string) {
  cookies.remove(cookieName)
  sendToNative('CLEAR_NATIVE_COOKIE', { name: cookieName })
}
